import { render, staticRenderFns } from "./colorize.vue?vue&type=template&id=423c772b"
import script from "./colorize.vue?vue&type=script&lang=js"
export * from "./colorize.vue?vue&type=script&lang=js"
import style0 from "./colorize.vue?vue&type=style&index=0&id=423c772b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports